const config = window.PersonDataSubmissionViewModel;

export default config;
